/* global axios */
import ApiClient from '../ApiClient';

class MetaBusinessAgentConversationControlAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true, saas: true });
  }

  get(conversationId) {
    return axios.get(
      `${this.url}/${encodeURIComponent(conversationId)}/meta_business_agent_control`
    );
  }

  release(conversationId, idempotencyKey) {
    return axios.post(
      `${this.url}/${encodeURIComponent(conversationId)}/meta_business_agent_control`,
      {
        thread_control_action: 'release',
        idempotency_key: idempotencyKey,
      }
    );
  }
}

export default new MetaBusinessAgentConversationControlAPI();
